import * as PreferenceApi from 'api/PreferenceApi';

const UPSERT = 'pulp/userSettings/UPSERT';
const ACCEPT_SITE_UPDATE = 'pulp/userSettings/ACCEPT_SITE_UPDATE';

export const initialState = {
  notesTitle: 'Notes from your agent',
  hasAcceptedSiteUpdate: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPSERT:
      return {...state, ...action.payload};
    case ACCEPT_SITE_UPDATE:
      return {
        ...state,
        hasAcceptedSiteUpdate: true
      };
    default:
      return state;
  }
}

export function loadUserSettings(payload) {
  return {type: UPSERT, payload};
}

export function changeUserSettings(payload, reportType) {
  PreferenceApi.updateV2Preferences(payload, reportType);
  return loadUserSettings(payload);
}

export function acceptSiteUpdate() {
  return {
    type: ACCEPT_SITE_UPDATE
  };
}
